/* tslint:disable */
/* eslint-disable */
/**
 * MedicalOperations API
 * This is an OpenAPI for the MedicalOperations Microservice
 *
 * OpenAPI spec version: 0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import globalAxios, { AxiosResponse, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { GetCalendarResponse } from '../models';
/**
 * CalendarApi - axios parameter creator
 * @export
 */
export const CalendarApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Gets appointments based on a filter to be dislplayed in a calendar format. Filters based upon employee id (Optional), patient id (Optional), month and week day. It is automatically filtered by branch and tenant. Can be called by employees.
         * @summary Gets appointments based on a filter to be dislplayed in a calendar format.
         * @param {Date} startdate date of the first day of the week to filter
         * @param {string} [employeeID] ID of the employee to filter
         * @param {string} [patientID] ID of the patient to filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilteredCalendar: async (startdate: Date, employeeID?: string, patientID?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startdate' is not null or undefined
            if (startdate === null || startdate === undefined) {
                throw new RequiredError('startdate','Required parameter startdate was null or undefined when calling getFilteredCalendar.');
            }
            const localVarPath = `/Calendar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Access-Token")
                    : await configuration.apiKey;
                localVarHeaderParameter["Access-Token"] = localVarApiKeyValue;
            }

            if (employeeID !== undefined) {
                localVarQueryParameter['employeeID'] = employeeID;
            }

            if (patientID !== undefined) {
                localVarQueryParameter['patientID'] = patientID;
            }

            if (startdate !== undefined) {
                localVarQueryParameter['startdate'] = (startdate as any instanceof Date) ?
                    (startdate as any).toISOString() :
                    startdate;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CalendarApi - functional programming interface
 * @export
 */
export const CalendarApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Gets appointments based on a filter to be dislplayed in a calendar format. Filters based upon employee id (Optional), patient id (Optional), month and week day. It is automatically filtered by branch and tenant. Can be called by employees.
         * @summary Gets appointments based on a filter to be dislplayed in a calendar format.
         * @param {Date} startdate date of the first day of the week to filter
         * @param {string} [employeeID] ID of the employee to filter
         * @param {string} [patientID] ID of the patient to filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFilteredCalendar(startdate: Date, employeeID?: string, patientID?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<GetCalendarResponse>>> {
            const localVarAxiosArgs = await CalendarApiAxiosParamCreator(configuration).getFilteredCalendar(startdate, employeeID, patientID, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * CalendarApi - factory interface
 * @export
 */
export const CalendarApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Gets appointments based on a filter to be dislplayed in a calendar format. Filters based upon employee id (Optional), patient id (Optional), month and week day. It is automatically filtered by branch and tenant. Can be called by employees.
         * @summary Gets appointments based on a filter to be dislplayed in a calendar format.
         * @param {Date} startdate date of the first day of the week to filter
         * @param {string} [employeeID] ID of the employee to filter
         * @param {string} [patientID] ID of the patient to filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFilteredCalendar(startdate: Date, employeeID?: string, patientID?: string, options?: AxiosRequestConfig): Promise<AxiosResponse<GetCalendarResponse>> {
            return CalendarApiFp(configuration).getFilteredCalendar(startdate, employeeID, patientID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CalendarApi - object-oriented interface
 * @export
 * @class CalendarApi
 * @extends {BaseAPI}
 */
export class CalendarApi extends BaseAPI {
    /**
     * Gets appointments based on a filter to be dislplayed in a calendar format. Filters based upon employee id (Optional), patient id (Optional), month and week day. It is automatically filtered by branch and tenant. Can be called by employees.
     * @summary Gets appointments based on a filter to be dislplayed in a calendar format.
     * @param {Date} startdate date of the first day of the week to filter
     * @param {string} [employeeID] ID of the employee to filter
     * @param {string} [patientID] ID of the patient to filter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public async getFilteredCalendar(startdate: Date, employeeID?: string, patientID?: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<GetCalendarResponse>> {
        return CalendarApiFp(this.configuration).getFilteredCalendar(startdate, employeeID, patientID, options).then((request) => request(this.axios, this.basePath));
    }
}
